<template>
	<div>
		<div class="inner with-content with-tables">
	        <div class="headline">
	            <h1>{{$t('clients.index.headline')}}</h1>
	        </div>
            <div v-if="openCreate" class="creating-modal-container">
              <div class="modal-mask" v-on:click="close"></div>
              <div class="modal-wrapper">
                <div class="modal-container creating-modal">
                    <div class="close" v-on:click="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="11.891" height="11.891" viewBox="0 0 23.781 23.781">
                          <path class="fill-grey" d="M382.829,147l8.485,8.485a2,2,0,0,1-2.829,2.829L380,149.829l-8.485,8.485a2,2,0,0,1-2.829-2.829L377.172,147l-8.486-8.485a2,2,0,0,1,2.829-2.829L380,144.172l8.485-8.486a2,2,0,0,1,2.829,2.829Z" transform="translate(-368.125 -135.125)"/>
                        </svg>
                    </div>
                    <h2>{{ $t('clients.create.headline') }}</h2>
                    <div class="inputs">
                        <input :placeholder="$t('clients.index.name-placeholder')" type="text" v-model="create.name" />
                        <div class="see-more" v-on:click="toggleMore">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="8.906" height="15.906" viewBox="0 0 17.813 31.812">
                                    <path class="fill-white" d="M576.5,158.3l-13.8-13.8a2.279,2.279,0,0,1,0-3.029l13.8-13.8a2,2,0,0,1,2.828,2.828l-12.485,12.485,12.485,12.486A2,2,0,1,1,576.5,158.3Z" transform="translate(-562.125 -127.094)"/>
                                </svg>
                            </div>
                            <div class="content">
                                <p class="title"><span>{{$t('clients.create.details')}}</span> {{$t('clients.create.details-optional')}}</p>
                                <p class="description">{{$t('clients.create.details-decription')}}</p>
                            </div>
                        </div>
                        <div class="more" v-if="showMoreFields">
                            <input :placeholder="$t('clients.index.email-placeholder')" type="text" v-model="create.email" />
                            <input :placeholder="$t('clients.index.phone-placeholder')" type="text" v-model="create.phone" />
                            <input :placeholder="$t('clients.index.address-placeholder')" type="text" v-model="create.address" />
                            <input :placeholder="$t('clients.index.zipcode-placeholder')" type="text" v-model="create.zipcode" />
                            <input :placeholder="$t('clients.index.city-placeholder')" type="text" v-model="create.city" />
                            <input :placeholder="$t('clients.index.vatno-placeholder')" type="text" v-model="create.vatno" />
                            <input :placeholder="$t('clients.index.bank-name-placeholder')" type="text" v-model="create.bank_name" />
                            <input :placeholder="$t('clients.index.bank-regno-placeholder')" type="text" v-model="create.bank_regno" />
                            <input :placeholder="$t('clients.index.bank-accountno-placeholder')" type="text" v-model="create.bank_accountno" />
                        </div>
                    </div>
                    <button v-if="editId"
                        class="purple button"
                        :disabled="creating"
                        v-on:click="saveClient()">
                        {{ $t('clients.index.save-client') }}
                        <span v-if="creating"> ...</span>
                    </button>
                    <button v-else
                        disabled
                        class="button purple"
                        v-on:click="createClient()">
                            {{ $t('clients.index.create-client') }}
                            <span v-if="creating"> ...</span>
                    </button>
                </div>
              </div>
            </div>
	        <tabs>
	            <tab :name="$t('clients.index.tabs.all')">
	                <v-client-table :columns="columns" :data="clients" :options="options" ref="table" class="client-table">
	                    <div slot="beforeFilter" class="intro">
	                        <h2>{{$t('clients.index.sub-headline')}}</h2>
	                    </div>
	                    <div slot="afterFilter" class="add-button">
                            <div class="data-input select-field sorting" style="display: none;">
                                <div class="select-container">
                                    <select v-model="tableSorting" v-on:click="setTableSorting('table', tableSorting)">
                                        <option value="">{{ $t('sort.newest-first') }}</option>
                                        <option value="10">{{ $t('sort.oldest-first') }}</option>
                                        <option value="20">{{ $t('sort.contracts-ascending') }}</option>
                                        <option value="25">{{ $t('sort.contracts-descending') }}</option>
                                        <option value="30">{{ $t('sort.screenings-ascending') }}</option>
                                        <option value="35">{{ $t('sort.screenings-descending') }}</option>
                                        <option value="40">{{ $t('sort.properties-ascending') }}</option>
                                        <option value="45">{{ $t('sort.properties-descending') }}</option>
                                    </select>
                                   <span class="arrow">
                                        <SvgIcon icon="sort-icon" />
                                    </span>
                                </div>
                            </div>
	                        <form>
                                <div class="icon">
                                    <SvgIcon icon="search" />
                                </div>
                                <input type="text" v-model="filterText" v-on:keyup="filterTable('table')" autofill="off" autocomplete="false" :placeholder="$t('search.filterplaceholder')">
                            </form>
	                        <a v-on:click="toggleCreate()" class="button green">
	                            <SvgIcon icon="plus-circle" />
	                            {{$t('clients.new.button')}}
	                        </a>
	                    </div>
                        <div slot="name" slot-scope="props" class="data-label" :data-label="$t('clients.table.name')">
                            {{ props.row.name }}
                        </div>
                        <div slot="properties" slot-scope="props" class="data-label" :data-label="$t('clients.table.properties')">
                            {{ props.row.properties }}
                        </div>
                        <div slot="screenings" slot-scope="props" class="data-label" :data-label="$t('clients.table.screenings')">
                            {{ props.row.screenings }}
                        </div>
                        <div slot="contracts" slot-scope="props" class="data-label" :data-label="$t('clients.table.contracts')">
                            {{ props.row.contracts }}
                        </div>
                        <a slot="more" slot-scope="props">
	                        <table-dropdown>
	                            <li v-on:click="editClient(props.row.id)">{{$t('clients.index.edit')}}</li>
	                        </table-dropdown>
	                    </a>
	                </v-client-table>
	            </tab>
	        </tabs>
	    </div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
    import createEntity from "../../mixins/create-entity";
    import Modal from '../../components/Modal';
    import TableDropdown from '../../components/TableDropdown';
    import SvgIcon from '../../components/Svg.vue';

	export default {
        mixins: [createEntity],
        data: () => ({
            filterText: '',
        	create: {
        		name: '',
        		email: '',
        		phone: '',
        		address: '',
        		zipcode: '',
        		city: '',
        		vatno: '',
        		bank_accountno: '',
        		bank_name: '',
        		bank_regno: ''
        	},
        	creating: false,
            showMoreFields: false,
        	editId: false,
        	rawClients: [],
        	openCreate: false,
        	tableSorting: '',
            columns: ['name', 'properties', 'screenings', 'contracts', 'more'],
            options: {
                headings: {
                    name: 'Name',
                    properties: 'properties',
                    screenings: 'screenings',
                    contracts: 'contracts',
                    more: 'More'
                },
                sortable: ['name', 'properties', 'screenings', 'contracts'],
                filterable: ['name'],
                texts:{
                    filterPlaceholder: 'Search',
                    filter: '',
                    noResults: ''
                },
                customSorting: {
                    oldFirst: function (ascending) {
                        return function (a, b) {
                            return ascending ? -1 : 1;
                        }
                    }
                },
                columnsClasses:{
                    more: 'more'
                }
            }
		}),
		components: {
			TableDropdown,
            Modal,
            SvgIcon
		},
		computed: {
			...mapGetters([
				'getToken'
			]),
			clients() {
				var result = [];
				for (var i in this.rawClients) {
					let client = this.rawClients[i];
					result.push({
						id: client.id,
						name: client.name,
						screenings: client.screenings,
						contracts: client.contracts,
						properties: client.properties
					});
				}
				return result;
			}
		},
        methods:{
            filterTable(ref, value) {
                this.$refs[ref].setFilter(this.filterText);
            },
        	toggleCreate() {
        		this.editId = false;
        		this.openCreate = !this.openCreate;
        	},
            close() {
                this.openCreate = false;
            },
            toggleMore() {
                this.showMoreFields = !this.showMoreFields;
            },
        	editClient(id) {
        		this.openCreate = true;
        		for (var i in this.rawClients) {
        			var client = this.rawClients[i];
        			if (client.id == id) {
        				this.editId = id;
        				this.create.name = client.name;
						this.create.email = client.email;
						this.create.phone = client.phone;
						this.create.address = client.address;
						this.create.zipcode = client.zipcode;
						this.create.city = client.city;
						this.create.vatno = client.vatno;
						this.create.bank_accountno = client.bank_accountno;
						this.create.bank_name = client.bank_name;
						this.create.bank_regno = client.bank_regno;
        			}
        		}
        	},
        	loadClients() {
        		axios({
                    method: 'GET',
                    url: window.config.apiUrl + 'api/client',

                }).then(response => {
                	this.rawClients = response.data;
                })
        	},
        	saveClient() {
        		this.creating = true;
        		axios({
                    method: 'PATCH',
                    url: window.config.apiUrl + 'api/client/' + this.editId,

                    data: this.create
                }).then(response => {
                	this.afterSave();
                	this.$store.commit('setSuccessBarMessage', this.$t('clients.client-saved.label'));
                }).finally(e => {
                	this.creating = false;
                });
        	},
        	createClient() {
        		this.creating = true;
        		axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/client',

                    data: this.create
                }).then(response => {
                	this.afterSave();
                	this.$store.commit('setSuccessBarMessage', this.$t('clients.client-created.label'));
                    if (this.$route.query.redirect) {
                        this.$router.push('/properties/add?client-id=' + response.data.id);
                    }
                }).finally(e => {
                	this.creating = false;
                });
        	},
        	afterSave() {
            	this.loadClients();
            	this.creating = false;
            	for (var i in this.create) {
            		this.create[i] = '';
            	}
            	this.openCreate = false;
        	},
            setTableSorting(ref, algo) {
                switch (String(algo)) {
                    case '':
                        this.$refs[ref].setOrder('oldFirst', false);
                        break;
                    case '10':
                        this.$refs[ref].setOrder('oldFirst', true);
                        break;
                    case '20':
                        this.$refs[ref].setOrder('contracts', true);
                        break;
                    case '25':
                        this.$refs[ref].setOrder('contracts', false);
                        break;
                    case '30':
                        this.$refs[ref].setOrder('screenings', true);
                        break;
                    case '35':
                        this.$refs[ref].setOrder('screenings', false);
                        break;
                    case '40':
                        this.$refs[ref].setOrder('properties', true);
                        break;
                    case '45':
                        this.$refs[ref].setOrder('properties', false);
                        break;
                }
            }
        },
		created() {
            this.options.headings.name = this.$t('clients.table.name');
            this.options.headings.properties = this.$t('clients.table.properties');
            this.options.headings.screenings = this.$t('clients.table.screenings');
            this.options.headings.contracts = this.$t('clients.table.contracts');
            this.options.headings.more = this.$t('tables.more.label');
            this.options.texts.noResults = this.$t('table.no-results.label');
            this.loadClients();

            if (this.$route.query.create == '1') {
                this.openCreate = true;
            }
		}
	}
</script>
